import React from 'react';
import clsx from 'clsx';

import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';

import { Hidden, makeStyles } from '@material-ui/core';

// Styles 
import useStyles from '../../../assets/styles/components/texts/readMoreLineStyle';

const ReadMoreLine = ({ text, line = 2 }) => {
    const classes = useStyles({line});
    const [clamped, setClamped] = React.useState(true);
    const [showButton, setShowButton] = React.useState(true);
    const containerRef = React.useRef(null);
    const handleClick = () => setClamped(!clamped);

  
    React.useEffect(() => {
      const hasClamping = (el) => {
        const { clientHeight, scrollHeight } = el;
        return clientHeight !== scrollHeight;
      };
  
      const checkButtonAvailability = () => {
        if (containerRef.current) {
          // Save current state to reapply later if necessary.
          const hadClampClass = containerRef.current.classList.contains("clamp");
          // Make sure that CSS clamping is applied if aplicable.
          if (!hadClampClass) containerRef.current.classList.add("clamp");
          // Check for clamping and show or hide button accordingly.
          setShowButton(hasClamping(containerRef.current));
          // Sync clamping with local state.
          if (!hadClampClass) containerRef.current.classList.remove("clamp");
        }
      };
  
    const debouncedCheck = (fn, delay) => {
        let timerId;
        return (...args) => {
          clearTimeout(timerId);
          timerId = setTimeout(() => fn(...args), delay);
        }
    };
  
    checkButtonAvailability();
        window.addEventListener("resize", debouncedCheck(checkButtonAvailability, 50));
    
        return () => {
            window.removeEventListener("resize", debouncedCheck(checkButtonAvailability, 50));
        };
    }, [containerRef]);
  
    return (
        <>
            <Box ref={containerRef} className={clsx(clamped && classes.clamp)}>
            {text}
            </Box>
            {showButton && (
              <>
              <Hidden smDown>
                <Link component="button" color="secondary" variant="body1"
                      className="semi-bold" 
                      onClick={handleClick}>Ver {clamped ? "más" : "menos"}
                  </Link>
              </Hidden>
              <Hidden smUp>
                <Link component="button" color="secondary" className='variant-xsmall mt-3'
                      onClick={handleClick}>Ver {clamped ? "más" : "menos"}
                  </Link>
              </Hidden>
            </>
            )}
        </>
    );
};

export default ReadMoreLine;